import React, { Component } from "react";
import { ListItem } from "../styled";
import { Link } from "react-router-dom";

class Item extends Component {
  render() {
    const { children, to, show = true, ...props } = this.props;
    return (
      <>
        {show && 
          <Link to={to}>
            <ListItem button {...props}>
              {children}
            </ListItem>
          </Link>
        
        }
      
      </>
    );
  }
}

export default Item;
